import sync from './sync'
/**
 * 予約媒体
 */
export default {
  namespaced: true,
  state: {
    byId: {
      0: '指定なし',
      1: 'ぐるなび',
      2: '食べログ',
      3: 'ホットペッパーグルメ',
      4: '一休',
      5: 'OZmall',
      6: 'オープンテーブル',
      7: 'ヒトサラ',
      8: 'ブッキングテーブル',
      9: 'ポンパレ',
      10: 'Retty',
      11: 'J-Dining',
      12: 'ベネフィット・ワン',
      13: 'PayPayグルメ',
      99: 'その他',
    },
    allIds: [0, 1, 2, 3, 4, 5, 10, 13, 6, 7, 8, 9, 11, 12, 99],
  },
  modules: {
    sync,
  },
  getters: {
    idsByName: ({ byId, allIds }) => allIds.reduce((byName, id) => Object.assign(byName, { [byId[id]]: id }), {}),
    allMap: ({ byId, allIds }) => new Map(allIds.map(id => [id, byId[id]])),
  },
}
